import script from "./Vastgoed.vue?vue&type=script&setup=true&lang=js"
export * from "./Vastgoed.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__